import { cva } from "class-variance-authority";
import { PlanStatus } from "creso-core/types";
import { Badge } from "web-design-system";

const variants = cva("!text-xxs w-fit", {
  variants: {
    status: {
      ACTIVE: "bg-tag-green text-tag-green-foreground",
      CANCELLED: "bg-tag-red text-tag-red-foreground",
      PAUSED: "bg-tag-grey text-tag-grey-foreground",
      COMPLETED: "bg-tag-blue text-tag-blue-foreground",
    },
  },
});

export function PlanStatusBadge({ status }: { status: PlanStatus }) {
  if (!status) return null;
  return (
    <Badge variant="custom" className={variants({ status })}>
      {status}
    </Badge>
  );
}
